import AwardCertificateCategory from './award&certificatecategory'
export default AwardCertificateCategory;